import React, { useCallback, useState } from 'react'
import PropTypes from 'prop-types'
import SydButton from '../../../../../../../commonDesign/Button'
import Icon from '../../../../../../../atoms/Icon'
import { useEvalRunForm } from '../../EvalRunFormContext'
import { useProposalCardStyles, useAutoApplyEffect } from './cardCommon'
import ProposalReviewModal from './ProposalReviewModal'

const PROPOSAL_NAME = 'propose_rubric'

function ProposedRubricCard ({ toolCallId, args, onApply, autoAccept }) {
  const classes = useProposalCardStyles()
  const { rubric, appliedProposalIds } = useEvalRunForm()
  const isApplied = !!toolCallId && appliedProposalIds.has(toolCallId)

  const [state, setState] = useState(isApplied ? 'applied' : 'pending')
  const [showModal, setShowModal] = useState(false)

  const apply = useCallback(({ auto = false } = {}) => {
    if (onApply) onApply({ tool: PROPOSAL_NAME, toolCallId, args })
    setState(auto ? 'auto-applied' : 'applied')
    setShowModal(false)
  }, [onApply, toolCallId, args])

  useAutoApplyEffect({ autoAccept, state, apply })

  if (state === 'applied' || state === 'auto-applied') {
    return (
      <div className={`${classes.root} ${classes.applied}`}>
        <div className={classes.appliedRow}>
          <Icon name='check' customSize='16px' />
          <span>{state === 'auto-applied' ? 'Rubric auto-applied' : 'Rubric applied'}</span>
        </div>
      </div>
    )
  }

  if (state === 'dismissed') {
    return (
      <div className={`${classes.root} ${classes.dismissed}`}>
        <div className={classes.dismissedRow}>Rubric proposal dismissed</div>
      </div>
    )
  }

  const summary = `Replace rubric (${args.rubric.length.toLocaleString()} chars)`

  return (
    <>
      <div className={classes.root}>
        <div className={classes.header}>
          <span className={classes.title}>Proposed rubric</span>
        </div>
        <div className={classes.summary}>{summary}</div>
        {args.reasoning && <div className={classes.reasoning}>{args.reasoning}</div>}
        <div className={classes.divider} />
        <div className={classes.actions}>
          <SydButton size='xs' variant='outline' onClick={() => setState('dismissed')}>
            Dismiss
          </SydButton>
          {onApply && (
            <SydButton size='xs' variant='ai' onClick={() => setShowModal(true)}>
              Review
            </SydButton>
          )}
        </div>
      </div>

      {showModal && (
        <ProposalReviewModal
          flavor='text'
          title='Review rubric change'
          reasoning={args.reasoning}
          textCurrent={rubric || ''}
          textProposed={args.rubric}
          onAccept={() => apply()}
          onReject={() => setShowModal(false)}
        />
      )}
    </>
  )
}

ProposedRubricCard.propTypes = {
  toolCallId: PropTypes.string,
  args: PropTypes.shape({
    rubric: PropTypes.string.isRequired,
    reasoning: PropTypes.string
  }).isRequired,
  onApply: PropTypes.func,
  autoAccept: PropTypes.bool
}

export default ProposedRubricCard
